<template>
  <v-card
    class="ma-0 pa-0 pt-2 px-1 create-simple-product-card"
    width="100%"
    flat
    :style="cardHeightStyle"
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-2 create-simple-product-header"
      :style="toolbarTitle ? { paddingTop: '10px' } : null"
      dense
      height="20"
    >
      <v-toolbar-title class="create-simple-product-title">
        <span class="me-2" v-if="toolbarTitle">
          {{ $t("product") }} / {{ $t("service") }}</span
        >
        <div v-if="showTypeSelector" class="product-type-toggle mt-2">
          <button
            type="button"
            :disabled="!!id"
            class="toggle-item"
            :class="{ active: type === 'product' }"
            @click="type = 'product'"
          >
            {{ $t("product") }}
          </button>
          <button
            type="button"
            :disabled="!!id"
            class="toggle-item"
            :class="{ active: type === 'service' }"
            @click="type = 'service'"
          >
            {{ $t("service") }}
          </button>
        </div>
      </v-toolbar-title>
      <v-checkbox
        v-if="!simple"
        v-model="status"
        :class="[toolbarTitle ? 'mt-6' : 'mt-2', 'mx-3']"
        :label="$t('status') + '  :  ' + (status ? $t('active') : $t('deactive'))"
        value="active"
      />
      <v-tooltip bottom :disabled="!wasVariableProduct">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-checkbox
              v-if="!simple && type === 'product'"
              v-model="isVariableProduct"
              :disabled="!!id || wasVariableProduct"
              :class="[toolbarTitle ? 'mt-6' : 'mt-2', 'mx-4']"
              :label="$t('variant-product')"
            />
          </div>
        </template>
        <span>{{ $t("cannot-unset-variable-product") }}</span>
      </v-tooltip>
      <v-checkbox
        v-if="!simple && type === 'product'"
        v-model="has_serial"
        true-value="active"
        false-value="deactive"
        :class="[toolbarTitle ? 'mt-6' : 'mt-2', 'mx-2']"
        :label="$t('product-serial')"
      />
      <!-- <v-checkbox
        v-if="!simple"
        v-model="isVariableProduct"
        :class="[toolbarTitle ? 'mt-6' : 'mt-2', 'mx-4']"
        :label="$t('variant-product')"
      /> -->
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo($route.name == 'Product' ? 'Product' : 'Service')"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("product") }} / {{ $t("service") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo(type == 'product' ? 'ProductList' : 'ServiceList')"
          >
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ type == "product" ? $t("productList") : $t("serviceList") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("back") }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      :key="'csp-form-' + formResetKey"
      ref="form"
      v-model="valid"
      lazy-validation
      class="create-simple-product-form"
    >
      <v-container v-if="simple" class="mt-3 create-simple-product-advance-scroll">
        <v-row class="">
          <v-col cols="12">
            <div class="d-flex align-center">
              <span class="me-2 text-body-1">
                {{ $t("specifications") }}
              </span>
              <v-divider class="flex-grow-1"></v-divider>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="1" class="pe-0">
            <file-picker
              ref="refFilePicker"
              v-model="imagePicker"
              :label="$t('uploadImage')"
              :avatar="true"
              :multiple="false"
              extensions="image/png, image/gif, image/jpeg"
              type-prop="productAvatar"
              :val="imagePickerVal ? imagePickerVal : null"
            />
          </v-col>
          <v-col
            cols="12"
            md="11"
            class="ps-0"
            :class="{
              'create-simple-product-advance-inputs-col-desktop': !isMobile,
              'create-simple-product-advance-inputs-col-mobile': isMobile,
            }"
          >
            <v-row>
              <v-col cols="12" md="3" sm="3" class="mb-0">
                <v-text-field
                  v-model="name"
                  :label="$t('name')"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :hide-details="false"
                  height="20"
                  dense
                  outlined
                  class="mb-1 dense"
                  autofocus
                  clearable
                />
              </v-col>
              <v-col v-show="type == 'product'" cols="12" md="3" sm="3" class="mb-0">
                <v-text-field
                  v-model="barcode"
                  :label="$t('barcode')"
                  height="20"
                  dense
                  outlined
                  class="mb-1 dense"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="3" sm="3" class="mb-0 pb-0" style="height: 55px">
                <aicomplete
                  ref="refUnit"
                  v-model="unit"
                  :val="unit"
                  title="unit"
                  type="unit"
                  :set-init="true"
                />
              </v-col>
              <v-col v-show="type == 'product'" cols="12" md="3" sm="3" class="mb-0">
                <autocomplete
                  v-model="kind"
                  :title="$t('productKind')"
                  type="productKind"
                  :value="kind"
                />
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <autocomplete
                  v-model="branch"
                  :title="$t('branch')"
                  type="branch"
                  :value="branch"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="11">
            <div class="d-flex align-center">
              <span class="me-2 text-body-1">
                {{ $t("tax&priceing") }}
              </span>
              <v-divider class="flex-grow-1"></v-divider>
            </div>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="taxid"
              :label="$t('taxisProduct')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="taxPercent"
              :label="$t('taxPercent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="mb-1">
            <money
              v-model="price"
              :label="$t('fixSellPrice')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              @input="calcPriceWithTax"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="mb-1">
            <money
              v-model="priceWithTax"
              :label="$t('priceWithTax')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              @input="calcPrice"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="mb-1">
            <money
              v-model="discount"
              :label="$t('discount')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="discountPercent"
              :label="$t('discountPercent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
        </v-row>
        <v-row v-if="type === 'product' && kind && kind.id === 112" class="mb-2">
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="constructionWagesPercent"
              :label="$t('construction_wages_percent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="profitPercent"
              :label="$t('profit_percent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="commissionPercent"
              :label="$t('commission_percent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col> </v-row
      ></v-container>

      <div v-if="!simple" class="create-simple-product-simple-shell">
        <v-tabs v-model="productTab" class="create-simple-product-tabs mt-3">
          <v-tab>{{ $t("specifications") }}</v-tab>
          <v-tab v-if="isVariableProduct">{{ $t("variant-product") }}</v-tab>
          <v-tab v-if="!isVariableProduct">{{ $t("pricing") }} {{ $t("advance") }}</v-tab>
          <v-tab v-if="!isVariableProduct">{{ $t("Integrator") }}</v-tab>
          <v-tab v-if="$store.state.shopSystem && !isVariableProduct">
            {{ $t("shop") }}
          </v-tab>
          <v-tab-item class="pt-2">
            <v-container>
              <v-row>
                <v-col cols="12" md="1" class="pe-0">
                  <file-picker
                    ref="refFilePicker"
                    v-model="imagePicker"
                    :label="$t('uploadImage')"
                    :avatar="true"
                    :multiple="false"
                    extensions="image/png, image/gif, image/jpeg"
                    type-prop="productAvatar"
                    :val="imagePickerVal ? imagePickerVal : null"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="11"
                  class="ps-0"
                  :class="{
                    'create-simple-product-advance-inputs-col-desktop': !isMobile,
                    'create-simple-product-advance-inputs-col-mobile': isMobile,
                  }"
                >
                  <v-row>
                    <v-col cols="12" md="3" sm="3" class="mb-0">
                      <v-text-field
                        v-model="name"
                        :label="$t('name')"
                        :rules="[(v) => !!v || $t('is-required')]"
                        :hide-details="false"
                        height="20"
                        dense
                        outlined
                        class="mb-1 dense"
                        autofocus
                        clearable
                      />
                    </v-col>
                    <v-col
                      v-show="type == 'product' && !isVariableProduct"
                      cols="12"
                      md="3"
                      class="mb-0"
                    >
                      <v-text-field
                        v-model="barcode"
                        :label="$t('barcode')"
                        height="20"
                        dense
                        outlined
                        class="mb-1 dense"
                        clearable
                      />
                    </v-col>
                    <v-col v-if="!isVariableProduct" cols="12" md="2" class="mb-0">
                      <v-text-field
                        v-model="code"
                        :label="$t('code')"
                        height="20"
                        dense
                        outlined
                        class="mb-1 dense"
                        clearable
                        @blur="checkCode"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-0 pb-0" style="height: 55px">
                      <aicomplete
                        ref="refUnit"
                        v-model="unit"
                        :val="unit"
                        title="unit"
                        type="unit"
                        :set-init="true"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-0 pb-0" style="height: 55px">
                      <v-text-field
                        v-model="displayPriority"
                        :label="$t('displayPriority')"
                        height="20"
                        dense
                        type="number"
                        outlined
                        class="mb-1 dense"
                        clearable
                      />
                    </v-col>
                    <v-col
                      v-if="!isVariableProduct"
                      cols="12"
                      md="3"
                      class="mb-0 pb-0"
                      style="height: 55px"
                    >
                      <v-text-field
                        v-model="custom_code"
                        :label="$t('Custom financial ID')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col
                      v-show="type == 'product'"
                      cols="12"
                      md="3"
                      sm="3"
                      class="mb-0"
                    >
                      <autocomplete
                        v-model="kind"
                        :title="$t('productKind')"
                        type="productKind"
                        :value="kind"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <description ref="refContent" v-model="content" type="product" />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-expansion-panels v-model="panel" class="mt-8">
                <v-expansion-panel>
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("tax&priceing") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("taxisProduct") }} , {{ $t("taxPercent") }} ,
                        {{ $t("fixSellPrice") }} , {{ $t("discount") }} , ...
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mb-2">
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="taxid"
                          :label="$t('taxisProduct')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="taxPercent"
                          :label="$t('taxPercent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        sm="3"
                        md="3"
                        class="mb-1"
                      >
                        <money
                          v-model="price"
                          :label="$t('fixSellPrice')"
                          :dense="true"
                          :outlined="true"
                          :solo="false"
                          :clearable="true"
                          value-when-is-empty=""
                          :options="options"
                          @input="calcPriceWithTax"
                        />
                      </v-col>
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        sm="3"
                        md="3"
                        class="mb-1"
                      >
                        <money
                          v-model="priceWithTax"
                          :label="$t('priceWithTax')"
                          :dense="true"
                          :outlined="true"
                          :solo="false"
                          :clearable="true"
                          value-when-is-empty=""
                          :options="options"
                          @input="calcPrice"
                        />
                      </v-col>
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        sm="3"
                        md="3"
                        class="mb-1"
                      >
                        <money
                          v-model="discount"
                          :label="$t('discount')"
                          :dense="true"
                          :outlined="true"
                          :solo="false"
                          :clearable="true"
                          value-when-is-empty=""
                          :options="options"
                        />
                      </v-col>
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0"
                      >
                        <v-text-field
                          v-model="discountPercent"
                          :label="$t('discountPercent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <!-- add kalabarg -->
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0 d-flex align-center"
                      >
                        <v-checkbox
                          v-model="isKalaBarg"
                          :label="$t('isKalaBarg')"
                          class="mt-0"
                          hide-details
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="type === 'product' && kind && kind.id === 112"
                      class="mb-2"
                    >
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="constructionWagesPercent"
                          :label="$t('construction_wages_percent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="profitPercent"
                          :label="$t('profit_percent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="commissionPercent"
                          :label="$t('commission_percent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-show="type == 'product' && !isVariableProduct">
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("otherBarcodes") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("otherBarcodesDescrible") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mb-3">
                      <v-col cols="12" sm="3">
                        <v-btn color="primary" small outlined @click="addBarcode">
                          {{ $t("addBarcode") }}
                          <v-icon class="ms-2"> mdi-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-for="(item, i) in barcodes" :key="i">
                      <v-col cols="12" md="4" class="mb-0">
                        <v-text-field
                          v-model="item.value"
                          :label="$t('barcode')"
                          height="20"
                          dense
                          :rules="[(v) => !!v || $t('is-required')]"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-btn
                          color="pink"
                          small
                          outlined
                          height="32"
                          @click="removeBarcode(item)"
                        >
                          <v-icon> mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("grouping,tags") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("tag") }} , {{ $t("group") }} , {{ $t("category") }} , ...
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mb-2">
                      <v-col
                        class="mb-0 pb-0"
                        style="height: 55px"
                        cols="12"
                        md="3"
                        sm="3"
                      >
                        <aicomplete
                          ref="refGroup"
                          v-model="group"
                          :val="group"
                          title="main-group"
                          type="productGroup"
                          :data="JSON.stringify({ parent: 0, type: 'group' })"
                          :new-btn="true"
                          :set-init="!id ? true : false"
                        />
                      </v-col>
                      <v-col
                        class="mb-0 pb-0"
                        style="height: 55px"
                        cols="12"
                        md="3"
                        sm="3"
                      >
                        <aicomplete
                          ref="refCat1"
                          v-model="cat1"
                          :val="cat1"
                          title="other-group"
                          type="productGroup"
                          :data="
                            JSON.stringify({
                              parent: group ? group.id : null,
                              type: 'category',
                            })
                          "
                          :new-btn="true"
                          :set-init="!id ? true : false"
                        />
                      </v-col>
                      <v-col
                        class="mb-0 pb-0"
                        style="height: 55px"
                        cols="12"
                        md="3"
                        sm="3"
                      >
                        <aicomplete
                          ref="refCat2"
                          v-model="cat2"
                          :val="cat2"
                          title="category"
                          type="productGroup"
                          :data="
                            JSON.stringify({
                              parent: cat1 ? cat1.id : null,
                              type: 'subcategory',
                            })
                          "
                          :new-btn="true"
                          :set-init="!id ? true : false"
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3">
                        <tag v-model="tag" :solo="false" :input="tag" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-show="type == 'product'">
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("dimensions") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("weight") }} , {{ $t("length") }} , {{ $t("width") }} ,
                        {{ $t("height") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="4" md="4" class="">
                        <v-text-field
                          v-model="length"
                          :label="$t('length')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                          type="number"
                        />
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="">
                        <v-text-field
                          v-model="width"
                          :label="$t('width')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                          type="number"
                        />
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="">
                        <v-text-field
                          v-model="height"
                          :label="$t('height')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                          type="number"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="mb-2">
                      <v-col cols="12" md="4" class="mb-0">
                        <v-text-field
                          v-model="weight"
                          :label="$t('weight') + '(kg)'"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  v-show="
                    $store.state.isMainYear && type == 'product' && !isVariableProduct
                  "
                >
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("initial-stock") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("initialStockInOtherEntrepot") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="3">
                        <v-btn
                          v-show="initialCheck"
                          color="primary"
                          small
                          outlined
                          class="mt-2"
                          @click="addInitialStock"
                        >
                          {{ $t("addInitialStock") }}
                          <v-icon class="ms-2"> mdi-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row
                      v-for="(initial, i) in initial_stocks"
                      v-show="$store.state.isMainYear && type == 'product'"
                      :key="i"
                      class="mb-2"
                    >
                      <v-col cols="12" :sm="has_serial === 'active' ? 2 : 3">
                        <v-text-field
                          v-model="initial.stock"
                          :label="$t('count')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                          :disabled="!initialCheck"
                          type="number"
                          @input="validateStock(initial)"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        :sm="has_serial === 'active' ? 2 : 3"
                        :md="has_serial === 'active' ? 2 : 3"
                        class="mb-1"
                      >
                        <money
                          v-model="initial.price"
                          :label="$t('fee')"
                          :dense="true"
                          :outlined="true"
                          :solo="false"
                          :clearable="true"
                          value-when-is-empty="0"
                          :disabled="!initialCheck"
                          :options="options"
                        />
                      </v-col>
                      <v-col
                        class="mb-0 pb-0"
                        cols="12"
                        md="4"
                        sm="4"
                        style="height: 55px"
                      >
                        <autocomplete
                          ref="refEntrepot"
                          v-model="initial.entrepot"
                          :rules="entrepotRuls(initial)"
                          :title="$t('entrepot')"
                          :value="entrepot"
                          :hide-details="false"
                          type="entrepot"
                          :disabled="!initialCheck"
                          @input="checkEntrepot(initial, i)"
                        />
                      </v-col>
                      <v-col
                        v-if="has_serial === 'active'"
                        class="mb-0 pb-0"
                        cols="12"
                        md="2"
                        sm="2"
                        style="height: 55px"
                      >
                        <v-btn
                          color="primary"
                          small
                          outlined
                          height="32"
                          class="mt-0"
                          :disabled="!initialCheck || !initial.entrepot || !initial.entrepot.id"
                          @click="openInitialStockSerialDialog(initial)"
                        >
                          <v-icon small class="me-1 serial-barcode-icon">mdi-barcode</v-icon>
                          {{ $t("serial-management") }}
                        </v-btn>
                      </v-col>
                      <v-col
                        class="mb-0 pb-0"
                        cols="12"
                        md="2"
                        sm="2"
                        style="height: 55px"
                      >
                        <v-btn
                          v-show="initialCheck"
                          color="pink"
                          small
                          outlined
                          height="32"
                          @click="removeInitialStock(i)"
                        >
                          <v-icon> mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-show="type == 'product'">
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("otherUnits") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("initialStockInOtherEntrepot") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row v-show="type == 'product'" class="mb-3">
                      <v-col cols="12" sm="3">
                        <v-btn color="primary" small outlined @click="addUnitRow">
                          {{ $t("addSub-unit") }}
                          <v-icon class="ms-2"> mdi-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-for="(item, i) in units" v-show="type == 'product'" :key="i">
                      <v-col class="mb-0 pb-0" cols="12" md="2" style="height: 55px">
                        <autocomplete
                          v-model="item.unit"
                          :rules="[(v) => !!v || $t('is-required')]"
                          :title="$t('unit')"
                          :value="item.unit"
                          type="unit"
                          :set-init="true"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="pt-5">
                        1 {{ item.unit ? item.unit.name : "" }} =
                        {{ item.value ? item.value : 1 }} {{ unit.name }}
                      </v-col>
                      <v-col cols="12" md="2" class="mb-0">
                        <v-text-field
                          v-model="item.value"
                          :label="$t('value')"
                          height="20"
                          dense
                          :rules="[(v) => !!v || $t('is-required')]"
                          outlined
                          class="mb-1 dense"
                          clearable
                          type="number"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="mb-0">
                        <v-checkbox
                          v-model="item.default"
                          :label="$t('defaultUnit')"
                          value="active"
                          class="mt-0"
                          @change="clearDefaultUnits(item, i)"
                        />
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="">
                        <v-btn
                          v-show="initialCheck"
                          color="pink"
                          small
                          outlined
                          height="32"
                          @click="removeUnit(item)"
                        >
                          <v-icon> mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="!isMobile && customFieldsPermission">
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("customFields") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("customeFeildDescrible") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <custom-fields
                      v-model="customFields"
                      :value="customFields"
                      type-prop="productCustomFields"
                      class="px-4"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div>
                      <div>{{ $t("otherSetting") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("otherSettingDescrible") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" md="3">
                        <autocomplete
                          v-model="branch"
                          :title="$t('branch')"
                          type="branch"
                          :value="branch"
                        />
                      </v-col>
                      <v-col
                        v-show="type == 'product' && !isVariableProduct"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0"
                      >
                        <v-text-field
                          v-model="orderPoint"
                          :label="$t('orderPoint')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col
                        v-show="type == 'product'"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0"
                      >
                        <v-select
                          v-model="inventoryMethod"
                          :label="$t('inventoryMethod')"
                          :items="inventoryMethodItems"
                          height="30"
                          dense
                          outlined
                          item-value="value"
                          item-text="text"
                        />
                      </v-col>
                      <v-col
                        v-show="type == 'product'"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0"
                      >
                        <v-select
                          v-model="priceMethod"
                          :label="$t('priceMethod')"
                          :items="priceMethodItems"
                          height="30"
                          dense
                          outlined
                          item-value="value"
                          item-text="text"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="!isMobile && customFieldsPermission"> </v-row>
                    <v-row v-show="type == 'product'" class="mb-3" style="height: 28px">
                      <v-subheader>
                        {{ $t("investor") }}
                      </v-subheader>
                      <v-tooltip v-if="!isVariableProduct" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            icon
                            small
                            class="float-left mt-2"
                            v-on="on"
                            @click="addInvestorRow"
                          >
                            <v-icon color="teal" style="font-size: 22px">
                              mdi-plus-box-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("addInvestor") }}</span>
                      </v-tooltip>
                    </v-row>
                    <v-row
                      v-for="(item, i) in investors"
                      v-show="type == 'product'"
                      :key="i"
                    >
                      <v-col
                        v-if="!isVariableProduct"
                        class="mb-0 pb-0"
                        cols="12"
                        md="3"
                        style="height: 55px"
                      >
                        <autocomplete
                          v-model="item.investor"
                          :rules="[(v) => !!v || $t('is-required')]"
                          :title="$t('investor')"
                          :value="item.investor"
                          type="person"
                          :new-btn="true"
                          :data="JSON.stringify({ type: 'investor' })"
                          @input="changeInvestor(item)"
                        />
                      </v-col>
                      <v-col v-if="!isVariableProduct" cols="12" md="3" class="mb-0">
                        <v-text-field
                          v-model="item.investorSellPercent"
                          :label="$t('investorSellPercent')"
                          height="20"
                          dense
                          :rules="[(v) => !!v || $t('is-required')]"
                          outlined
                          type="number"
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col v-if="!isVariableProduct" cols="12" md="3" class="mb-0">
                        <v-text-field
                          v-model="item.investorReturnSellPercent"
                          :label="$t('investorReturnSellPercent')"
                          height="20"
                          dense
                          :rules="[(v) => !!v || $t('is-required')]"
                          outlined
                          type="number"
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" class="">
                        <v-tooltip v-if="!isVariableProduct" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="pink"
                              icon
                              small
                              v-bind="attrs"
                              class="ms-2"
                              v-on="on"
                              @click="removeInvestor(item)"
                            >
                              <v-icon color="pink" style="font-size: 22px">
                                mdi-close-box
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("remove") }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div>
                      <div>{{ $t("image-gallery") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("upload your images") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="pa-0 ma-0">
                      <v-col cols="12" md="3" class="pa-0">
                        <file-picker
                          ref="refProductImages"
                          v-model="productImages"
                          :label="$t('uploadImage')"
                          :multiple="true"
                          extensions="image/png, image/gif, image/jpeg"
                          type-prop="productImages"
                          :val="productImagesVal ? productImagesVal : null"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- add allocation -->
                <v-expansion-panel>
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("allocation") }}</div>
                      <div class="abr-subtitle mt-2 mb-1">
                        {{ $t("allocationProductDescribe") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mb-3" style="height: 28px">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            icon
                            small
                            class="float-left mt-2"
                            v-on="on"
                            @click="addAllocationRow"
                          >
                            <v-icon color="teal" style="font-size: 22px">
                              mdi-plus-box-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("addAllocation") }}</span>
                      </v-tooltip>
                      <v-subheader class="pa-0 ma-0">
                        {{ $t("allocationPercent") }}
                      </v-subheader>
                    </v-row>
                    <v-row v-for="(item, i) in allocations" :key="'allocation-' + i">
                      <v-col cols="12" md="3" class="mb-0">
                        <v-text-field
                          v-model="item.percent"
                          :placeholder="$t('allocationPercent')"
                          height="20"
                          dense
                          outlined
                          type="number"
                          class="mb-1 dense"
                          hide-details
                          clearable
                          suffix="%"
                        />
                      </v-col>
                      <v-col cols="12" md="3" class="mb-0">
                        <v-text-field
                          :id="'allocationFromDate' + i"
                          v-model="item.from_date"
                          :placeholder="$t('fromDate')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          hide-details
                          clearable
                        />
                        <date-picker
                          v-model="item.from_date"
                          :element="'allocationFromDate' + i"
                          :locale="$store.state.date_locale"
                          :format="$store.state.date_format"
                          auto-submit
                          :color="
                            $vuetify.theme.themes[
                              $vuetify.theme.isDark ? 'dark' : 'light'
                            ].primary
                          "
                        />
                      </v-col>
                      <v-col cols="12" md="3" class="mb-0">
                        <v-text-field
                          :id="'allocationToDate' + i"
                          v-model="item.to_date"
                          :placeholder="$t('toDate')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          hide-details
                          clearable
                        />
                        <date-picker
                          v-model="item.to_date"
                          :element="'allocationToDate' + i"
                          :locale="$store.state.date_locale"
                          :format="$store.state.date_format"
                          auto-submit
                          :color="
                            $vuetify.theme.themes[
                              $vuetify.theme.isDark ? 'dark' : 'light'
                            ].primary
                          "
                        />
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="pink"
                              icon
                              small
                              v-bind="attrs"
                              class="ms-2"
                              v-on="on"
                              @click="removeAllocation(item)"
                            >
                              <v-icon color="pink" style="font-size: 22px">
                                mdi-close-box
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("remove") }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="isVariableProduct">
            <variable-product-tab
              v-model="variableVariants"
              :product-name="name"
              :costs="costs"
              :price-method="priceMethod"
              :initial-check="initialCheck"
              :product-type="type"
              :has-serial="has_serial"
            />
          </v-tab-item>
          <v-tab-item>
            <pricing
              v-model="pricing"
              :costs="costs"
              :method="priceMethod"
              :value="pricing"
            />
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <v-row class="pa-0 ma-0">
                <v-tabs vertical>
                  <v-tab>
                    <v-icon class="me-3"> mdi-wordpress </v-icon>
                    {{ $t("woocommerce") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="me-2" src="@/assets/digikala.png" />
                    {{ $t("digikala") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="me-2" src="@/assets/basalam.png" />
                    {{ $t("basalam") }}
                  </v-tab>
                  <v-tab>
                    <img width="20" class="me-4" src="@/assets/markitoLogo.png" />
                    {{ $t("markito") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="10" class="me-4" src="@/assets/portal.png" />
                    {{ $t("portal") }}
                  </v-tab>
                  <!-- <portal3 /> -->
                  <v-tab align="right">
                    <img width="10" class="me-4" src="@/assets/portal.png" />
                    {{ $t("portal3") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="me-4" src="@/assets/sazito.png" />
                    {{ $t("sazito") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="me-4" src="@/assets/webzi.png" />
                    {{ $t("webzi") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="mx-4" src="@/assets/integrators/mixin.png" />
                    {{ $t("mixin") }}
                  </v-tab>
                  <v-tab align="right">
                    <img
                      width="20"
                      class="mx-4"
                      src="@/assets/integrators/snapShop.png"
                    />
                    {{ $t("snap-shop") }}
                  </v-tab>
                  <v-tab-item>
                    <v-container>
                      <v-row class="mx-0">
                        <v-col cols="6" class="px-0">
                          <v-btn
                            color="primary"
                            class="mr-0"
                            outlined
                            :loading="isLoading"
                            @click="addWoocommerceIdItems"
                          >
                            {{ $t("addId") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row v-for="(item, h) in woocommerceIdItems" :key="h">
                        <v-col cols="12" md="3" class="mb-0">
                          <autocomplete
                            v-model="item.woocommercePanelName"
                            :title="$t('woocommercePanelName')"
                            :value="item.woocommercePanelName"
                            type="woocommercePanelName"
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.woocommerceId"
                            :label="$t('woocommerceId') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.woocommerceVariantId"
                            :label="$t('woocommerceVariantId') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.woocommerceFixCount"
                            :label="$t('woocommerceFixCount') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="3" class="mb-0">
                          <v-btn
                            color="pink"
                            small
                            outlined
                            height="32"
                            @click="removeWoocommerceId(item)"
                          >
                            <v-icon> mdi-trash-can-outline </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <digikala-integrator
                      @update="getPanels"
                      :digikalaPanel="digikalaPanel"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <v-container>
                      <v-row class="mx-0">
                        <v-col cols="6" class="px-0">
                          <v-btn
                            color="primary"
                            class="mr-0"
                            outlined
                            :loading="isLoading"
                            @click="addBaSalamIdItems"
                          >
                            {{ $t("addId") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row v-for="(item, h) in basalamIdItems" :key="h">
                        <v-col cols="12" md="3" class="mb-0">
                          <autocomplete
                            v-model="item.basalamPanelName"
                            :title="$t('basalamPanelName')"
                            :value="item.basalamPanelName"
                            type="basalamPanelName"
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.basalamId"
                            :label="$t('basalamId') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.basalamVariantId"
                            :label="$t('basalamVariantId') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="3" class="mb-0">
                          <v-btn
                            color="pink"
                            small
                            outlined
                            height="32"
                            @click="removeBaSalamId(item)"
                          >
                            <v-icon> mdi-trash-can-outline </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="markitoId"
                            :label="$t('markitoId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="portalId"
                            :label="$t('portalId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="portalVariantId"
                            :label="$t('portalVariantId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <!-- <portal-3-integrator /> -->
                  <v-tab-item>
                    <Portal3Integrator
                      @updatePortal="getPortalPanels"
                      :portalPanel="portalPanel"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <sazito-integrator
                      @updateSazito="getSazitoPanels"
                      :sazitoPanel="sazitoPanel"
                    />
                  </v-tab-item>

                  <v-tab-item>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="webziId"
                            :label="$t('webziId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="webziVariantId"
                            :label="$t('webziVariantId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <mixin-integrator
                      @updateMixin="getMixinPanels"
                      :mixinPanel="mixinPanel"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <snapshop-integrator
                      @updateSnapshop="getSnapshopPanels"
                      :snapshopPanel="snapshopPanel"
                    />
                  </v-tab-item>
                </v-tabs>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="$store.state.shopSystem">
            <v-container>
              <v-row class="pa-0 ma-0">
                <v-col cols="12" class="my-0 px-1 py-0" style="height: auto !important">
                  <tiptap-vuetify
                    v-model="body"
                    :extensions="extensions"
                    :toolbar-attributes="{ color: '#ababab', dark: true }"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </div>
      <v-card-actions class="pa-0 ma-0 create-simple-product-actions">
        <div class="create-simple-product-actions-wrap">
          <v-row class="ma-0 d-flex justify-space-between align-center">
            <v-col cols="6" class="px-1 d-flex align-start">
              <v-btn
                v-if="!id"
                v-shortkey="['shift', 'f3']"
                color="primary"
                class="ml-2"
                :loading="isLoading"
                @shortkey="shortkeyCreateSubmit"
                @click="create(true)"
              >
                {{ $t("submit") }}
              </v-btn>
              <v-btn
                v-if="!id"
                v-shortkey="['shift', 'f4']"
                color="primary"
                class="ml-2"
                :loading="isLoading"
                @shortkey="shortkeyCreateSubmitNew"
                @click="create(false)"
              >
                {{ $t("submit&new") }}
              </v-btn>
              <v-btn
                v-if="id"
                v-shortkey="['shift', 'f3']"
                color="primary"
                class="mr-0"
                :loading="isLoading"
                @shortkey="update"
                @click="update"
              >
                {{ $t("submit") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="px-2 d-flex align-center justify-end">
              <v-btn
                color="gray"
                class=""
                :loading="isLoading"
                outlined
                @click="triggertoAdvance"
              >
                {{ simple ? $t("create_advance_product") : $t("create_simple_product") }}
              </v-btn>
              <v-btn
                v-if="!formType"
                color="grey"
                outlined
                class="mr-3"
                @click="goTo(type == 'product' ? 'ProductList' : 'ServiceList')"
              >
                {{ type == "product" ? $t("productList") : $t("serviceList") }}
              </v-btn>
            </v-col>
          </v-row>
          <p class="create-simple-product-shortcuts-hint ma-0 ms-1">
            <template v-if="!id">
              Shift+F3 {{ $t("submit") }} · Shift+F4 {{ $t("submit&new") }}
            </template>
            <template v-else>Shift+F3 {{ $t("submit") }}</template>
          </p>
        </div>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <serial-management-dialog
      v-model="serialDialog"
      :product="serialDialogProduct"
      :entrepot="(serialItem && serialItem.entrepot) || {}"
      :total-count="serialItem && serialItem.stock"
      :serials="(serialItem && serialItem.serials) || []"
      serial-flow="in"
      :selected-serials="(serialItem && serialItem.serials) || []"
      @confirm="setInitialStockSerials"
    />
  </v-card>
</template>

<script>
export default {
  name: "ProductFormDesktopView",
};
</script>

<style>
/* Unscoped for Bridge (View is not mounted). Rules match git HEAD; Vuetify internals scoped under card. */
.create-simple-product-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.create-simple-product-header {
  position: sticky;
  top: 2;
  z-index: 4;
  background: #fff;
  flex: 0 0 auto;
}
.product-type-toggle {
  display: inline-flex;
  align-items: center;
  background: #ffff;
  border-radius: 4px;
  border: 1px solid #bdbdbd;
  overflow: hidden;
}
.product-type-toggle .toggle-item {
  border: 0;
  background: transparent;
  color: #424242;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  min-width: 74px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.product-type-toggle .toggle-item.active {
  background: #1976d2;
  color: #ffffff;
  font-weight: 600;
}
.product-type-toggle .toggle-item:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.create-simple-product-form {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.create-simple-product-advance-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
.create-simple-product-advance-greeting {
  margin-left: 2px;
  margin-bottom: 4px;
  font-size: 14px;
}
.create-simple-product-advance-inputs-col-desktop {
  padding-right: 24px !important;
}
.create-simple-product-advance-inputs-col-mobile {
  padding-right: 12px !important;
}
.create-simple-product-simple-shell {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.create-simple-product-tabs.v-tabs {
  flex: 1 1 auto;
  min-height: 0;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}
.create-simple-product-tabs > .v-tabs-bar {
  flex: 0 0 auto !important;
}
.create-simple-product-tabs > .v-tabs-items,
.create-simple-product-tabs > .v-window {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  -webkit-overflow-scrolling: touch;
}
.create-simple-product-actions {
  position: sticky;
  bottom: 0;
  z-index: 4;
  background: #fff;
  flex: 0 0 auto;
  border-top: 1px solid #bdbdbd;
  min-height: 65px;
  padding: 4px 6px 6px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
}
.create-simple-product-actions-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.create-simple-product-actions .v-row {
  align-items: center;
  min-height: 44px;
}
.create-simple-product-actions .v-col {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.create-simple-product-actions .v-btn {
  min-height: 30px !important;
  height: 30px !important;
}
.create-simple-product-shortcuts-hint {
  font-size: 10px;
  line-height: 1.35;
  color: #9e9e9e;
  padding: 0px 0px 0;
  width: 100%;
}
.create-simple-product-card
  .v-input.v-textarea.v-textarea--auto-grow.v-textarea--no-resize.theme--light.v-text-field {
  height: 35px;
  border: 1px solid silver;
}
.create-simple-product-card .v-text-field.v-text-field--solo .v-input__control {
  height: 32px;
  margin-bottom: 0;
}
.create-simple-product-card .v-textarea.v-text-field--solo .v-input__append-outer {
  margin-top: 6px;
  margin-left: 8px;
}
.create-simple-product-card
  .v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense)
  .v-label {
  top: 7px !important;
}
.create-simple-product-card
  .v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense)
  textarea {
  margin-top: 4px;
}
.create-simple-product-card .v-textarea.v-text-field--solo .v-input__append-inner {
  margin-top: 5px;
}
</style>